<div class="bs-container flex-column gap-1" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div class="text-xs font-medium uppercase pb-2">
    {{ title }}
  </div>
  <div class="header pt-1">
    <app-input-text #searchInput name="search" label="Filtra i dati" icon="search" [form]="searchForm" placeholder="Cerca..." clearable></app-input-text>
  </div>
  <mat-accordion *ngIf="insertFormTemplateRef" displayMode="flat">
    <mat-expansion-panel hideToggle class="shadow-none">
      <mat-expansion-panel-header>
        <mat-panel-title class="flex justify-content-center text-primary">
          Inserisci nuovo elemento
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <ng-container
            *ngTemplateOutlet="insertFormTemplateRef; context: {form: insertForm}"
          >
        </ng-container>
        <div class="p-1"></div>
        <app-button label="Salva" raised fullWidth (click)="onSaveClick()" [disabled]="!insertForm.valid"></app-button>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="border-round border-1 border-200 p-1 bottom-sheet-content">
    @for (item of filteredList(); track trackByIndex; let i=$index; let last = $last;) {
      <div (click)="onClick(item)" class="cursor-pointer p-1" [ngClass]="{'bg-primary-50': 0 === i % 2, 'bg-white': 0 !== i % 2 }">
        <ng-container
          *ngIf="bodyTemplateRef else defaultTemplate"
          [ngTemplateOutlet]="bodyTemplateRef"
          [ngTemplateOutletContext]="{$implicit:item}"

        >
        </ng-container>
        <ng-template #defaultTemplate>
          <!-- Il tuo template di fallback va qui -->
          <span>test</span>
        </ng-template>
      </div>
      <mat-divider *ngIf="!last"></mat-divider>
    }
  </div>
</div>
